var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMissedAllerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    rx: 12,
    fill: "#00BB8E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2729_15908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 23.3334C11.3968 23.3334 7.66602 19.6026 7.66602 15.0001C7.66602 10.3976 11.3968 6.66675 15.9993 6.66675C20.6018 6.66675 24.3327 10.3976 24.3327 15.0001C24.3327 19.6026 20.6018 23.3334 15.9993 23.3334ZM15.9993 21.6667C17.7675 21.6667 19.4632 20.9644 20.7134 19.7141C21.9636 18.4639 22.666 16.7682 22.666 15.0001C22.666 13.232 21.9636 11.5363 20.7134 10.286C19.4632 9.03579 17.7675 8.33341 15.9993 8.33341C14.2312 8.33341 12.5355 9.03579 11.2853 10.286C10.0351 11.5363 9.33268 13.232 9.33268 15.0001C9.33268 16.7682 10.0351 18.4639 11.2853 19.7141C12.5355 20.9644 14.2312 21.6667 15.9993 21.6667ZM15.166 17.5001H16.8327V19.1667H15.166V17.5001ZM15.166 10.8334H16.8327V15.8334H15.166V10.8334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2729_15908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissedAllerts);
export default __webpack_public_path__ + "static/media/missedAllerts.21ec925054d6820188d4736ce6937e7d.svg";
export { ForwardRef as ReactComponent };